import type { Option } from '../../../../components/DataTable/DataTable.types';

import { Button } from '../../../../components/Button';
import { ToggleGroup } from '../../../../components/ToggleGroup';

interface DataTableSingleFilterProps {
  title?: string;
  options: Option[];
  selectedValues: Set<string>;
  onSelectValue: (option: Option) => void;
  onClear: () => void;
}

export function DataTableSingleFilter({
  title,
  options,
  selectedValues,
  onSelectValue,
  onClear,
}: DataTableSingleFilterProps) {
  const selectedValue = selectedValues.size === 1 ? Array.from(selectedValues)[0] : undefined;
  const items = options.map((option) => ({ label: option.label, value: String(option.value) }));

  const handleValueChange = (value: string) => {
    const option = options.find((item) => String(item.value) === value);

    if (option) onSelectValue(option);
  };

  return (
    <div className="space-y-2">
      <ToggleGroup
        className="h-auto w-full justify-start"
        name={title}
        options={items}
        value={selectedValue}
        onChange={handleValueChange}
      />
      {selectedValue && (
        <Button variant="ghost" size="sm" className="h-8 w-full justify-center" onClick={onClear}>
          Clear filter
        </Button>
      )}
    </div>
  );
}
